import type { CatalogLoadMoreTranslations } from "./pl";

export const de: CatalogLoadMoreTranslations = {
  loadMore: "Mehr laden",
  loading: "Wird geladen...",
  shown: (shown: number, total: number) => `${shown} von ${total} angezeigt`,
};
